export default __webpack_public_path__ + "static/media/Inther.fd428a3c.png";